<template>
  <FormSubmitPopup
    :title="isIMEI ? $t('editIMEI') : $t('editSN')"
    v-model="value"
    @popupClose="$emit('input', false)"
    :rightMethod="onSubmitted"
    :rightButtonText="$t('confirm')"
    large
  >
    <template v-slot:input>
      <v-container>
        <v-combobox
          :value="snArrayInEdit"
          chips
          multiple
          deletable-chips
          prepend-icon="filter_list"
          :suffix="snArrayInEdit.length.toString()"
          @change="onSnChanged"
          clearable></v-combobox>
      </v-container>
    </template>
  </FormSubmitPopup>
</template>

<script>
import FormSubmitPopup from './FormSubmitPopup'
import {cloneDeep, mediaTools, isValidIMEI} from '../utils/tools'

export default {
  name: 'SnArrayEditPopup',
  components: {
    FormSubmitPopup
  },
  mixins: [mediaTools],
  data () {
    return {
      snArrayInEdit: [],
      soundToggle: true,
      soundPitch: 1,
      soundSettings: {
        success: () => {},
        hint: () => {},
        warning: () => {},
        tracking: () => {},
        upc: () => {}
      }
    }
  },
  mounted () {
    if (this.snArray) {
      this.snArrayInEdit = cloneDeep(this.snArray)
    }
    this.soundToggle = window.localStorage.getItem('inbound.soundToggle' + this.$store.getters.uid)
    this.soundToggle = (this.soundToggle !== undefined && this.soundToggle === 'true') || false
    this.soundPitch = Number(window.localStorage.getItem('inbound.soundPitch' + this.$store.getters.uid) || 1)
    this.onSoundPitchChanged()
  },
  methods: {
    async onSubmitted () {
      if (this.checkQuantity && this.checkQuantity !== this.snArrayInEdit.length) {
        if (!confirm(this.$t('existIMEIQuantityError'))) {
          return
        }
      }
      const {snArrayInEdit} = this
      this.$emit('submitted', [...new Set(snArrayInEdit.map(item => item.toUpperCase()))])
    },
    playSound (type = 'hint') {
      if (this.soundToggle) this.soundSettings[type]()
    },
    onSoundPitchChanged (value = true) {
      this.soundSettings.hint = value ? this.hintSound(this.soundPitch) : () => {}
      this.soundSettings.success = value ? this.successSound(this.soundPitch) : () => {}
      this.soundSettings.warning = value ? this.warningSound(this.soundPitch) : () => {}
      this.soundSettings.upc = value ? this.upcSound(this.soundPitch) : () => {}
      this.soundSettings.tracking = value ? this.trackingSound(this.soundPitch) : () => {}
      return value || this.closeSound()
    },
    snTemplate () {
      const upcMap = this.$store.getters.upcMap || {}
      const { snTemplate = '' } = upcMap[this.upc] || {}
      return snTemplate
    },
    onSnChanged (value) {
      let updateVal = value
      let sound = 'success'
      const newValue = value[value.length - 1]
      if (value.length && value.some(item => !this.snArray.includes(item))) {
        let isDup = newValue && this.snItems && this.snItems.some(item => item.snArray.includes(newValue.toUpperCase()))
        if (this.allItems) {
          isDup = this.allItems.includes(newValue)
        }
        if (isDup) {
          alert(this.$t(this.isIMEI ? 'duplicateIMEI' : 'duplicateSn', { part: '' }))
          sound = 'warning'
          updateVal = value.slice(0, value.length - 1)
        }
        if (this.isIMEI) {
          if (!isValidIMEI(newValue)) {
            alert(this.$t('invalidIMEI', { part: '' }))
            sound = 'warning'
            updateVal = value.slice(0, value.length - 1)
          }
        } else {
          const snTemplate = this.snTemplate()
          if (snTemplate && newValue.length > snTemplate.length) {
            alert(this.$t('doesNotMeetLengthRules', { part: '' }))
            sound = 'warning'
            updateVal = value.slice(0, value.length - 1)
          }
        }
      }
      this.snArrayInEdit = [...new Set(updateVal)]
      this.playSound(sound)
    }
  },
  props: {
    value: Boolean,
    snArray: Array,
    upc: String,
    checkQuantity: Number,
    isIMEI: Boolean,
    allItems: {
      type: Array,
      default: () => []
    },
    snItems: {
      type: Array,
      default: () => []
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SnArrayEditPopup.vue